<mat-label class="mb-8 mobile-hint">{{'INPUT.MOBILE-HINT' | translate}}</mat-label>
<div class="table-container">
    <ng-container>
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <table style="width:100%">
            <tr>
                <th *ngFor="let header of tableConfig?.columns">{{header.description}}</th>
            </tr>
            <tr *ngFor="let row of value; let index = index">
                <td *ngFor="let column of tableConfig?.columns">
                    <span  [attr.contenteditable]="!ngControl.disabled" (focus)="selectText()"
                           (blur)="updateList(row, column.code, $event)">
                        {{row[column.code]}}
                    </span>
                </td>
                <td *ngIf="value.length > 1 && !ngControl.disabled">
                    <button mat-icon-button (click)="remove(row, index)"><mat-icon>delete</mat-icon></button>
                </td>
            </tr>
        </table>
    </ng-container>
</div>

<button *ngIf="!ngControl.disabled" mat-icon-button
        (click)="addRow()"><mat-icon>add</mat-icon></button>

<ng-container *ngIf="ngControl.touched">
    <mat-error *ngIf="ngControl.control.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
    <mat-error *ngIf="ngControl.control.hasError('email')">{{'INPUT.INVALID_EMAIL' | translate}}</mat-error>
    <mat-error *ngIf="ngControl.control.hasError('maxLength')">{{'INPUT.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-error>
    <mat-error *ngIf="ngControl.control.hasError('max')">{{'INPUT.MAX_VALUE' | translate }}</mat-error>
    <mat-error *ngIf="ngControl.control.hasError('min')">{{'INPUT.MIN_VALUE' | translate }}</mat-error>
    <mat-error *ngIf="ngControl.control.hasError('pattern')">{{'INPUT.BAD_FORMAT' | translate }}</mat-error>

</ng-container>
